import React, { Fragment } from "react";
import { createUseStyles } from "react-jss";
import { ThemeType } from "../../styles/theme";

interface Props {
  item: {
    subTitle: string;
    title: string;
    reverseColor?: boolean;
  };
  isGuideDetailPage: boolean;
}

const useStyles = createUseStyles((theme: ThemeType) => ({
  subTitle: {
    padding: ({ isGuideDetailPage }: Props) =>
      `${isGuideDetailPage ? 60 : 22}px ${theme.gap}px 0`,
    position: "relative",
    fontSize: "1.6rem",
    lineHeight: "2.2rem",
    color: ({ item }: Props) =>
      item.reverseColor ? theme.mono50 : theme.mono100,
  },
  title: {
    padding: `2px ${theme.gap}px 0`,
    height: ({ isGuideDetailPage }: Props) =>
      isGuideDetailPage ? "auto" : 114,
    position: "relative",
    fontSize: ({ isGuideDetailPage }: Props) =>
      isGuideDetailPage ? "2.7rem" : "2.6rem",
    fontWeight: theme.medium,
    lineHeight: ({ isGuideDetailPage }: Props) =>
      isGuideDetailPage ? "3.7rem" : "3.6rem",
    color: ({ item }: Props) =>
      item.reverseColor ? "rgb(34, 34, 34)" : theme.mono100,
  },
}));

const Caption: React.FC<Props> = (props) => {
  const classes = useStyles(props);
  const { item } = props;

  return (
    <>
      <p className={classes.subTitle}>{item.subTitle}</p>
      <h1 className={classes.title}>
        {item.title.split("\n").map((item: string, key: number) => {
          return (
            <Fragment key={key}>
              {item}
              <br />
            </Fragment>
          );
        })}
      </h1>
    </>
  );
};

export default Caption;
